import {
	UPDATE_STORE_ACCESS_TYPE,
	SET_STORE_ACCESS_TYPE,
	RESET_STATE,
	ADD_BATCH_LIST,
	EDIT_BATCH_LIST_ITEM,
	REMOVE_BATCH_LIST_ITEM,
	ADD_BATCH_LIST_ITEM_ROW,
} from './storeAccessTypes.actions';

// utils
import _uniqueId from 'lodash/uniqueId';

const defaultState = {
	data: {
		storeAccessType: {},
		batchList: [
			{
				identifier: _uniqueId('row-'),
				coffee: 5,
				anyItem: 3,
			},
		],
	},
};

function reducer(state = defaultState, action) {
	const { type, payload } = action;

	switch (type) {
		case SET_STORE_ACCESS_TYPE: {
			return {
				data: {
					storeAccessType: payload,
				},
			};
		}

		case UPDATE_STORE_ACCESS_TYPE: {
			return {
				data: {
					storeAccessType: {
						...state.data.storeAccessType,
						...payload,
					},
				},
			};
		}

		case RESET_STATE: {
			return {
				...defaultState,
			};
		}

		case ADD_BATCH_LIST: {
			return {
				...state,
				data: {
					...state.data,
					batchList: payload,
				},
			};
		}

		case EDIT_BATCH_LIST_ITEM: {
			return {
				...state,
				data: {
					...state.data,
					batchList: state.data.batchList.map((entry) => {
						if (entry.identifier === payload.identifier) return payload;
						return entry;
					}),
				},
			};
		}

		case REMOVE_BATCH_LIST_ITEM: {
			return {
				...state,
				data: {
					...state.data,
					batchList: state.data.batchList.filter(
						(entry) => entry.identifier !== payload
					),
				},
			};
		}

		case ADD_BATCH_LIST_ITEM_ROW: {
			return {
				...state,
				data: {
					...state.data,
					batchList: [
						...state.data.batchList,
						{
							...defaultState.data.batchList[0],
							identifier: _uniqueId('row-'),
						},
					],
				},
			};
		}

		default:
			return state;
	}
}

export default reducer;
